import { createAsyncThunk } from '@reduxjs/toolkit';
import { getValidCardsOfUser } from '../services/getValidCardsOfUser.service';

export const loadValidCardsOfMultipleUsers = createAsyncThunk(
    'cards/loadValidCardsOfMultipleUsers',
    async (userIds) => {

        // Load cards for all users in parallel
        const cardPromises = userIds.map(async (userId) => {
            try {
                const cards = await getValidCardsOfUser(userId);
                return { userId, cards };
            } catch (error) {
                console.error(`Failed to load cards for user ${userId}:`, error);
                return { userId, cards: [] };
            }
        });

        const results = await Promise.all(cardPromises);

        // Convert to object format: { userId: [cards] }
        const cardsByUser = {};
        results.forEach(({ userId, cards }) => {
            cardsByUser[userId] = cards;
        });

        return cardsByUser;
    }
);
